<script setup>
import { ref, computed, onBeforeMount, defineProps, defineEmits } from "vue";
import EstadisticasTerritorioAmigable from "./EstadisticasTerritorioAmigable.vue";
import MapaSelectorTerritorio from "./MapaSelectorTerritorio/MapaSelectorTerritorio.vue";
import { useTrabajoStore } from "@/store/useTrabajoStore";
import { useTerritoriosEstadisticas } from "@/composables/useTerritoriosEstadisticas";

const props = defineProps({
  start: {
    type: Date,
    default: null,
  },
  onlyIncomplete: {
    type: Boolean,
    default: false,
  },
  selected: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(["selected"]);

const trabajo = useTrabajoStore();

onBeforeMount(async () => {
  await trabajo.syncHistory();
});

const viewMode = ref("lista");
const viewOptions = [
  { label: "Lista", value: "lista" },
  { label: "Mapa", value: "mapa" },
];

const { build } = useTerritoriosEstadisticas();
const items = computed(() =>
  props.start ? build(props.start, { onlyIncomplete: props.onlyIncomplete }) : []
);
</script>

<template>
  <div>
    <SelectButton
      v-model="viewMode"
      :options="viewOptions"
      optionLabel="label"
      optionValue="value"
      class="mb-2"
    />
    <EstadisticasTerritorioAmigable
      v-if="viewMode === 'lista'"
      :start="props.start"
      :onlyIncomplete="props.onlyIncomplete"
      :selectable="true"
      :selected="props.selected"
      @selected="emit('selected', $event)"
    />
    <MapaSelectorTerritorio
      v-else
      :items="items"
      :selected="props.selected"
      @selected="emit('selected', $event)"
    />
  </div>
</template>
